<template>
  <div class="detail country-detail" v-if="!notFound">
    <!-- 国家头部：遵循项目框架 .detail-banner + .detail-back -->
    <div class="detail-banner">
      <div class="container">
        <div class="cd-banner-inner">
          <img
            v-if="country.icon"
            :src="country.icon"
            :alt="country.name"
            class="cd-flag"
            @error="onImgError"
          />
          <span v-else class="cd-flag-placeholder">{{ country.name.slice(0, 1) }}</span>
          <div class="cd-banner-text">
            <h1 v-if="country.name">{{ country.name }}</h1>
            <div class="sub">国家资讯 · 政策 · 市场 · 服务机构</div>
          </div>
        </div>
      </div>
    </div>

    <div class="detail-body">
      <div class="container">
        <span class="detail-back" @click="$goBack()">‹ 返回</span>
        <!-- 官方必读资讯 -->
        <section class="cd-section" v-if="links.length">
          <h3 class="cd-title">
            官方必读资讯<span class="cd-free">（点击下方指南【免费】查看）</span>
          </h3>
          <div class="h-scroll">
            <div
              v-for="item in links"
              :key="item.id"
              class="link-card"
              @click="openUrl(item.url)"
            >
              <div class="link-card-cover">
                <img v-if="item.cover" :src="item.cover" :alt="item.name" @error="onImgError" />
                <span v-else class="cover-letter">指南</span>
                <div class="link-card-meta">
                  <div class="link-card-name">{{ item.name }}</div>
                  <div class="link-card-inst" v-if="item.institution">{{ item.institution }}</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- 国别报告 / 出海服务 入口 -->
        <section class="entry-row">
          <div class="entry-card" @click="$router.push('/country-report/' + id)">
            <div class="entry-icon">📑</div>
            <div class="entry-text">
              <div class="entry-title">{{ country.name }}国别报告</div>
              <div class="entry-sub">5分钟快速了解该国家 | 政策·市场·投资全解析</div>
            </div>
            <span class="entry-arrow"></span>
          </div>
          <div class="entry-card" @click="$router.push('/oversea-service')">
            <div class="entry-icon">🚀</div>
            <div class="entry-text">
              <div class="entry-title">出海服务</div>
              <div class="entry-sub">政企协同服务平台，企业出海坚实后盾</div>
            </div>
            <span class="entry-arrow"></span>
          </div>
        </section>

        <!-- 国家（地区）资讯 -->
        <section class="cd-section" v-if="resources.length">
          <h3 class="cd-title">国家（地区）资讯</h3>
          <div class="h-scroll">
            <div
              v-for="item in resources"
              :key="item.id"
              class="res-card"
              @click="openUrl(item.url)"
            >
              <div class="res-card-cover">
                <img v-if="item.icon" :src="item.icon" :alt="item.title" @error="onImgError" />
                <span v-else class="cover-letter">资讯</span>
              </div>
              <div class="res-card-title">{{ item.title }}</div>
            </div>
          </div>
        </section>

        <!-- 视频资料 -->
        <section class="cd-section" v-if="videos.length">
          <h3 class="cd-title">视频资料</h3>
          <div class="h-scroll">
            <div
              v-for="item in videos"
              :key="item.id"
              class="res-card"
              @click="openUrl(item.url)"
            >
              <div class="res-card-cover video">
                <img v-if="item.icon" :src="item.icon" :alt="item.title" @error="onImgError" />
                <span v-else class="cover-letter">视频</span>
                <span class="play-badge">▶</span>
              </div>
              <div class="res-card-title">{{ item.title }}</div>
            </div>
          </div>
        </section>

        <!-- 当地各领域专家/机构 -->
        <section class="cd-section">
          <h3 class="cd-title">当地各领域专家/机构</h3>
          <div v-if="experts.length" class="expert-list">
            <div
              v-for="exp in experts"
              :key="exp.id"
              class="expert-row"
              @click="$router.push('/expert/' + exp.id)"
            >
              <div class="expert-avatar-sm">
                <img v-if="exp.cover" :src="exp.cover" :alt="exp.name" @error="onImgError" />
                <span v-else>{{ exp.name.slice(0, 1) }}</span>
              </div>
              <div class="expert-meta">
                <div class="expert-name">{{ exp.name }}</div>
                <div class="expert-tags" v-if="exp.tags">{{ exp.tags }}</div>
              </div>
              <span class="expert-arrow">›</span>
            </div>
          </div>
          <div v-else class="empty-block">该地区暂未发布专家信息</div>
          <div class="expert-foot" v-if="experts.length">
            <span>平台拥有全球1000+专业认证人士为会员服务</span>
            <span class="contact-link" @click="contactUs">联系我们</span>
          </div>
        </section>
      </div>
    </div>
  </div>
  <div class="detail" v-else>
    <div class="detail-banner">
      <div class="container">
        <h1>国家资讯</h1>
      </div>
    </div>
    <div class="detail-body">
      <div class="container">
        <span class="detail-back" @click="$goBack()">‹ 返回</span>
        <div class="empty-block">未找到该国家资讯。</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  fetchCountryList,
  fetchCountryLinkInfo,
  fetchCountryResource,
  fetchCountryVideo,
  fetchCountryExperts
} from '../api/home'

export default {
  name: 'CountryDetail',
  props: ['id'],
  data () {
    return {
      country: { name: '', icon: '' },
      links: [],
      resources: [],
      videos: [],
      experts: [],
      loading: true,
      notFound: false
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      this.loading = true
      this.notFound = false
      const countryId = this.id
      try {
        // 先尽力按 id 从国家列表中匹配出国家名称与旗帜图标
        let baseName = ''
        let baseIcon = ''
        try {
          const groups = await fetchCountryList()
          const flat = groups.reduce((acc, g) => acc.concat(g.countries), [])
          const found = flat.find(c => String(c.id) === String(countryId))
          if (found) {
            baseName = found.name
            baseIcon = found.icon
          }
        } catch (e) { /* 列表兜底失败不影响主流程 */ }

        const [links, resources, videos, experts] = await Promise.all([
          fetchCountryLinkInfo(countryId),
          fetchCountryResource(countryId),
          fetchCountryVideo(countryId),
          fetchCountryExperts(countryId)
        ])
        this.links = links
        this.resources = resources
        this.videos = videos
        this.experts = experts.rows || []
        // 名称兜底：优先用列表匹配，否则用专家/链接信息
        this.country = {
          name: baseName ||
            (this.experts[0] && this.experts[0].countryName) ||
            (links.length ? links[0].institution : '') ||
            '国家资讯',
          icon: baseIcon
        }
      } catch (e) {
        this.notFound = true
        this.$toast.show({ message: (e && e.message) || '加载失败', type: 'error' })
      } finally {
        this.loading = false
      }
    },
    openUrl (url) {
      if (!url) {
        this.$toast.show({ message: '暂无可访问链接', type: 'error' })
        return
      }
      if (url.indexOf('http') === 0) {
        window.open(url, '_blank')
      } else {
        this.$toast.show({ message: '该内容暂仅支持小程序内查看', type: 'error' })
      }
    },
    contactUs () {
      this.$toast.show({ message: '如需更多资源，请联系客服', type: 'info' })
    },
    onImgError (e) {
      e.target.style.display = 'none'
    }
  }
}
</script>

<style scoped>
/* 国家头部 banner：遵循项目框架 .detail-banner */
.cd-banner-inner {
  flex-direction: row !important;
  align-items: center;
  gap: 16px;
}
.cd-flag {
  width: 64px;
  height: 64px;
  border-radius: 14px;
  object-fit: cover;
  background: #fff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
  flex-shrink: 0;
}
.cd-flag-placeholder {
  width: 64px;
  height: 64px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.25);
  color: #fff;
  font-size: 30px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.cd-banner-text h1 {
  font-size: 30px;
  font-weight: 800;
  letter-spacing: 1px;
}
.cd-banner-text .sub {
  margin-top: 6px;
  font-size: 15px;
  opacity: 0.9;
}

/* 通用板块 */
.cd-section {
  margin-top: 34px;
}
.cd-title {
  font-size: 20px;
  font-weight: 800;
  color: var(--text-main);
  position: relative;
  padding-left: 14px;
  margin: 0 0 18px;
}
.cd-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 4px;
  bottom: 4px;
  width: 5px;
  border-radius: 3px;
  background: linear-gradient(180deg, var(--primary-light), var(--primary));
}
.cd-free {
  font-size: 14px;
  font-weight: 600;
  color: var(--primary);
}

/* 官方必读资讯 卡片 */
.link-card {
  min-width: 210px;
  flex-shrink: 0;
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
  border: 1px solid var(--border);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.link-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 24px rgba(36, 68, 203, 0.18);
}
.link-card-cover {
  position: relative;
  height: 260px;
  background: linear-gradient(135deg, #6f9bff, var(--primary));
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.link-card-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.link-card-meta {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 12px 14px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7));
  color: #fff;
}
.link-card-name {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 4px;
}
.link-card-inst {
  font-size: 12.5px;
  opacity: 0.9;
}

/* 国别报告 / 出海服务 入口 */
.entry-row {
  margin-top: 30px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}
@media (max-width: 640px) {
  .entry-row { grid-template-columns: 1fr; }
}
.entry-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 22px;
  background: linear-gradient(135deg, #ffffff 0%, #f0f4f8 100%);
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.04);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.entry-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 28px rgba(36, 68, 203, 0.14);
}
.entry-icon {
  font-size: 30px;
  flex-shrink: 0;
}
.entry-text {
  flex: 1;
  min-width: 0;
}
.entry-title {
  font-size: 18px;
  font-weight: 800;
  color: #111827;
}
.entry-sub {
  font-size: 13px;
  color: #4b5563;
  margin-top: 6px;
  line-height: 1.5;
}
.entry-arrow {
  width: 12px;
  height: 12px;
  border-top: 3px solid #2563eb;
  border-right: 3px solid #2563eb;
  transform: rotate(45deg);
  flex-shrink: 0;
}

/* 资源 / 视频 卡片 */
.res-card {
  min-width: 220px;
  flex-shrink: 0;
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
  border: 1px solid var(--border);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.res-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 24px rgba(36, 68, 203, 0.16);
}
.res-card-cover {
  position: relative;
  height: 150px;
  background: linear-gradient(135deg, #38b6a4, #1f7a8c);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.res-card-cover.video {
  background: linear-gradient(135deg, #f0a04b, #d9772e);
}
.res-card-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.play-badge {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 4px;
}
.res-card-title {
  padding: 14px 16px;
  font-size: 14.5px;
  font-weight: 600;
  color: #333;
  text-align: center;
  line-height: 1.5;
  word-break: break-word;
  white-space: normal;
}

.cover-letter {
  color: #fff;
  font-size: 18px;
  font-weight: 800;
}

/* 专家/机构 列表 */
.expert-list {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 14px;
  overflow: hidden;
  box-shadow: var(--shadow);
}
.expert-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  cursor: pointer;
  border-bottom: 1px solid #e6e6e6;
  transition: background 0.2s ease;
}
.expert-row:last-child {
  border-bottom: none;
}
.expert-row:hover {
  background: var(--blue-soft-2, #f4f7fe);
}
.expert-avatar-sm {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: var(--blue-soft);
  color: var(--primary);
  font-weight: 800;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
}
.expert-avatar-sm img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.expert-meta {
  flex: 1;
  min-width: 0;
}
.expert-name {
  font-size: 16px;
  font-weight: 700;
  color: var(--text-main);
}
.expert-tags {
  font-size: 13px;
  color: var(--text-sub);
  margin-top: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.expert-arrow {
  font-size: 24px;
  color: #c2cbe0;
  flex-shrink: 0;
}
.expert-foot {
  margin-top: 18px;
  text-align: center;
  font-size: 14px;
  color: var(--text-sub);
  display: flex;
  justify-content: center;
  gap: 6px;
  flex-wrap: wrap;
}
.contact-link {
  color: var(--primary);
  font-weight: 600;
  cursor: pointer;
}
.contact-link:hover {
  text-decoration: underline;
}

.empty-block {
  text-align: center;
  color: var(--text-sub, #9aa6c0);
  padding: 30px 0;
}
</style>
